<template>
  <div
    class="scrollable"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <v-header></v-header>
    <div
      class="content"
      style="margin-bottom: 70px"
    >
      <div class="breadNav">
        <p>
          <em
            @click="gotoindex()"
            style="cursor:pointer;"
          >{{ $t("m.medicalReports.brankNav") }}</em><span
          class="addReport"
          @click="addReport"
        >+ {{ $t("m.medicalReports.addReportBtn") }}</span>
        </p>
      </div>
      <!-- <div class="nav">
    <div class="navChild">
      <div class="left">
        <p :class="{active:index==isActive}" v-for="(item,index) in navListLeft" @click="changeNav(index)">{{item}}</p>
      </div>
    </div>
  </div> -->
      <div
        class="titList"
        v-if="reportList.length > 0"
      >
        <p class="name">{{ $t("m.medicalReports.phyPerson") }}</p>
        <p class="msg">{{ $t("m.medicalReports.details") }}</p>
        <p class="time">{{ $t("m.medicalReports.time") }}</p>
        <p class="handle">{{ $t("m.medicalReports.handle") }}</p>
      </div>
      <div
        class="medicalList"
        v-if="reportList.length > 0"
      >
        <div
          class="medicalItem"
          :key="index"
          v-for="(item, index) in reportList"
        >
          <div class="name">
            <p>{{ item.relative.name }} - {{ item.relative.gender_text }}</p>
          </div>
          <div
            class="msg"
            v-if="item.delivery_way == 0"
          >
            <p>{{ item.hospital.name }}</p>
            <p></p>
            <p>
              {{ $t("m.phyOrderList.orderItem.orderNum") }}：{{ item.order_no }}
            </p>
          </div>
          <div
            class="msg"
            v-if="item.delivery_way == 2"
          >
            <p>{{ $t("m.medicalReports.selfUpload") }}</p>
          </div>
          <div class="time">
            <p>{{ item.exam_date }}</p>
          </div>
          <div class="handle">
            <p
              v-if="
                  item.delivery_way == 2 && item.delivery_way_text === 'image'
                "
              @click="getReportImg(item.content)"
            >
              {{ $t("m.medicalReports.getReport") }}
            </p>
            <p
              v-if="item.delivery_way == 0 || item.delivery_way_text === 'pdf'"
              @click="downloadReport(item.url)"
            >
              <a style="color: #ff000f !important">{{
                  $t("m.medicalReports.downloadReport")
                }}</a>
            </p>
            <!-- <p>对比个人体检报告</p> -->
            <p @click="interpret(item.id)">
              {{ $t("m.medicalReports.decode") }}
            </p>
            <p
              v-if="item.interpret !== 0"
              @click="getInterpretList(item)"
            >
              {{ $t("m.medicalReports.getInterpret") }}
            </p>
            <p
              @click="removeReport(item)"
              v-show="item.deletable"
            >
              {{ $t("m.medicalReports1.deleteReport") }}
            </p>
            <p @click="getItem(item)">疾病风险评估</p>
          </div>
        </div>
      </div>
      <div
        class="nayReport"
        v-else
      >
      <img src="../../../assets/tjbg.png" style="transform: scale(0.85);"/>
      <p>抱歉，暂无出具的体检报告可至<span style="color: #ff000f;text-decoration: underline;padding: 0 5px;cursor: pointer;" @click="gotorder()">我的订单</span>中查看详情，如您需<br>要本平台的报告解读服务，请上传您的体检报告。</p>
      </div>
    </div>
    <v-footer></v-footer>
    <!-- 疾病风险评估 -->
    <div id="interpret">
      <el-dialog
        center
        :visible.sync="appraiseVisible"
        :close-on-click-modal="false"
      >
        <div class="interpretMsg">
          <div class="tit">
            <p>疾病风险评估</p>
          </div>
          <div class="msg">
            <div class="appraiseTit">
              <i></i>
              <p>为更精准的预测您患心血管病的风险，请完善以下信息。</p>
            </div>
            <div class="appraiseMsg">
              <p>心血管家族病史</p>
              <el-radio-group
                v-model="appraiseForm.cardiovascular_disease_history"
                style="margin-left:83px;"
              >
                <el-radio :label="1">有</el-radio>
                <el-radio :label="0">无</el-radio>
              </el-radio-group>
            </div>
            <div class="appraiseMsg">
              <p>吸烟史</p>
              <el-radio-group
                v-model="appraiseForm.smoking_history"
                style="margin-left:147px;"
              >
                <el-radio :label="1">有</el-radio>
                <el-radio :label="0">无</el-radio>
              </el-radio-group>
            </div>
            <div class="appraiseMsg">
              <p>急性心血管事件</p>
              <el-radio-group
                v-model="appraiseForm.acute_cardiovascular_events"
                style="margin-left:83px;"
              >
                <el-radio :label="1">有</el-radio>
                <el-radio :label="0">无</el-radio>
              </el-radio-group>
            </div>
            <div
              class="appraiseMsg"
              v-if="needList.indexOf('ldl_c_value')!=-1"
            >
              <p>低密度脂蛋白(mmol/L)</p>
              <input
                type="text"
                v-model="appraiseForm.ldl_c_value"
                style="width:500px;margin-left:30px;font-size:16px;"
                placeholder="请填写低密度脂蛋白指数"
                @keyup="keyUp"
              />
            </div>
            <div
              class="appraiseMsg"
              v-if="needList.indexOf('hdl_c_value')!=-1"
            >
              <p>高密度脂蛋白(mmol/L)</p>
              <input
                type="text"
                v-model="appraiseForm.hdl_c_value"
                style="width:500px;margin-left:30px;font-size:16px;"
                placeholder="请填写高密度脂蛋白指数"
                @keyup="keyUp"
              />
            </div>
            <div
              class="appraiseMsg"
              v-if="needList.indexOf('tc_value')!=-1"
            >
              <p>总胆固醇(mmol/L)</p>
              <input
                type="text"
                v-model="appraiseForm.tc_value"
                style="width:500px;margin-left:62px;font-size:16px;"
                placeholder="请填写总胆固醇指数"
                @keyup="keyUp"

              />
            </div>
            <div
              class="appraiseMsg"
              v-if="needList.indexOf('diastolic_value')!=-1"
            >
              <p>舒张压(mmHg)</p>
              <input
                type="text"
                v-model="appraiseForm.diastolic_value"
                style="width:500px;margin-left:83px;font-size:16px;"
                placeholder="请填写舒张压指数"
                @keyup="keyUp"
              />
            </div>
            <div
              class="appraiseMsg"
              v-if="needList.indexOf('systolic_value')!=-1"
            >
              <p>收缩压(mmHg)</p>
              <input
                type="text"
                v-model="appraiseForm.systolic_value"
                style="width:500px;margin-left:83px;font-size:16px;"
                placeholder="请填写收缩压指数"
                @keyup="keyUp"
                maxlength="6"
              />
            </div>
          </div>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
                    <el-button
                      type="primary"
                      :loading="btnLoading"
                      @click="appraiseSubmit"
                    >获取疾病风险报告</el-button>
                </span>
      </el-dialog>
    </div>

    <!-- 查看已约解读列表 -->
    <div
      id="jdList"
      class="checkJdList"
    >
      <el-dialog
        :visible.sync="interpretListVisible"
        :close-on-click-modal="false"
        :title="$t('m.medicalReports.interpretListTit')"
      >
        <div
          class="interpretMsg"
          style="width: 100%"
        >
          <div id="interpretList">
            <div
              class="item"
              v-for="(item, index) in interpretListData"
              :key="index"
            >
              <div class="item1">
                <p
                  class="left"
                  style="width: 120px"
                >
                  {{ $t("m.medicalReports.creatDate") }}：
                </p>
                <p class="right">{{ item.create_time }}</p>
              </div>
              <div class="item1">
                <p
                  class="left"
                  style="width: 120px"
                >
                  {{ $t("m.medicalReports.creatName") }}：
                </p>
                <p class="right">{{ item.name }}</p>
              </div>
              <div class="item1">
                <p
                  class="left"
                  style="width: 120px"
                >
                  {{ $t("m.medicalReports.creatPhone") }}：
                </p>
                <p class="right">{{ item.contact }}</p>
              </div>
              <div class="item1">
                <p
                  class="left"
                  style="width: 120px"
                >
                  {{ $t("m.medicalReports.creatTime") }}：
                </p>
                <p class="right">{{ item.schedule }}</p>
              </div>
              <div
                class="item1"
                style="align-items: flex-start"
              >
                <p
                  class="left"
                  style="width: 120px"
                >
                  {{ $t("m.medicalReports1.doubt") }}
                </p>
                <p class="right">{{ item.doubt }}</p>
              </div>
              <div
                class="item1"
                id="jd_status"
                v-if="item.status_id === 0"
              >
                <p @click="cancelYY(item)">
                  {{ $t("m.medicalReports1.cancelReservation") }}
                </p>
              </div>
              <div
                class="item1"
                id="jd_status1"
                v-if="item.status_id === 2"
              >
                <p>{{ $t("m.medicalReports1.interpreted") }}</p>
              </div>
              <div
                class="item1"
                id="jd_status1"
                v-if="item.status_id === 3"
              >
                <p>{{ $t("m.medicalReports1.cancelled") }}</p>
              </div>
            </div>
          </div>
        </div>
        <p style="text-align: center; font-size: 16px; color: #333333">
          {{ $t("m.medicalReports1.customerNumber") }}
        </p>
      </el-dialog>
    </div>
    <!-- 体检报告解读 -->
    <div id="jdList">
      <el-dialog
        :visible.sync="interpretVisible"
        :title="$t('m.medicalReports.writeInterpret.tit')"
        :close-on-click-modal="false"
      >
        <div class="interpretMsg">
          <div id="writeInterpret">
            <div class="item">
              <div class="left">
                <p>{{ $t("m.medicalReports.writeInterpret.name") }}：</p>
              </div>
              <div class="right">
                <el-input
                  style="width: 100%"
                  v-model="interpretForm.name"
                  :placeholder="$t('m.medicalReports.writeInterpret.inputName')"
                ></el-input>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <p>{{ $t("m.medicalReports.writeInterpret.phone") }}：</p>
              </div>
              <div class="right">
                <el-input
                  style="width: 100%"
                  v-model="interpretForm.contact"
                  :placeholder="
                      $t('m.medicalReports.writeInterpret.inputPhone')
                    "
                ></el-input>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <p>{{ $t("m.medicalReports.writeInterpret.time") }}：</p>
              </div>
              <div class="right">
                <el-cascader
                  v-model="interpretForm.schedule"
                  :options="options"
                  :placeholder="$t('m.medicalReports.writeInterpret.inputTime')"
                ></el-cascader>
              </div>
            </div>
            <div
              class="item"
              style="align-items: flex-start !important"
            >
              <div
                class="left"
                style="margin-top: 5px"
              >
                <p>{{ $t("m.medicalReports1.doubt") }}</p>
              </div>
              <div class="right">
                <el-input
                  type="textarea"
                  :rows="5"
                  style="width: 100%"
                  v-model="interpretForm.doubt"
                  :placeholder="$t('m.medicalReports1.text1')"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
                    <el-button
                      type="primary"
                      :loading="btnLoading"
                      @click="submit"
                    >{{
                        $t("m.common.submit")
                      }}</el-button>
                </span>
      </el-dialog>
    </div>
    <!-- 上传体检报告 -->
    <div id="interpret">
      <el-dialog
        :visible.sync="addReportVisible"
        :close-on-click-modal="false"
      >
        <div class="addMsg">
          <div class="tit">
            <p style="font-weight:normal;font-size:20px;">{{ $t("m.medicalReports.uploadNewReport") }}</p>
          </div>
          <div class="person addReportSelect">
            <p class="icon"></p>
            <p class="title">{{ $t("m.medicalReports.choosePhyPerson") }}：</p>
            <em class="username">{{ username }}</em>
            <!-- <el-select
    v-model="phyVal"
    @change="changePhy"
    :placeholder="$t('m.medicalReports.choosePhyPerson')"
    style="margin-left: 10px; width: 100%"
  >
    <el-option
      v-for="(item, index) in phyExPeoList"
      :key="index"
      :label="item.name"
      :value="item.id"
      v-if="item.relationship === 0"
    >
    </el-option>
  </el-select> -->
          </div>
          <div class="time">
            <p class="icon"></p>
            <p class="title">{{ $t("m.medicalReports.choosePhyTime") }}：</p>
            <el-date-picker
              v-model="timeVal"
              type="date"
              :placeholder="$t('m.medicalReports.choosePhyTime')"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="getTime"
              :picker-options="pickerOptions"
              style="margin-left: 10px; width: 100%"
            >
            </el-date-picker>
          </div>
          <div class="uploadFile">
            <p
              class="icon"
              style="width:3px;"
            ></p>
            <p class="title">{{ $t("m.medicalReports.uploadFileTit") }}:<span
              style="font-size:14px;font-weight:normal;">（{{ $t("m.medicalReports.format") }}）</span></p>
          </div>
          <div class="uploadMsg">
            <el-upload
              action=""
              class="upload-demo"
              ref="upload"
              :on-change="fileChange"
              :on-remove="fileRemove"
              :file-list="fileList"
              :auto-upload="false"
              :multiple="true"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf"
            >
              <el-button
                size="small"
                type="primary"
              >{{
                  $t("m.medicalReports.uploadFileBtn")
                }}
              </el-button>
              <div
                slot="tip"
                class="el-upload__tip"
                style="color:#999999;"
              >
                {{ $t("m.common.uploadMsg") }}
              </div>
            </el-upload>
          </div>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
                    <el-button
                      type="primary"
                      :loading="btnLoading"
                      @click="submitUpload"
                    >{{ $t("m.common.submit") }}</el-button>
                </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {
        mapActions,
        mapGetters
    } from "vuex";
    import header from "../../common/header.vue";
    import footer from "../../common/footer.vue";
    import {
        QYconfig,
        quit
    } from "../../../utils/qiyukf";

    let phoneReg = /^1[3456789]\d{9}$/;
    export default {
        name: "medicalReports",
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                username: "",
                userId: null,
                fileList: [],
                interpretVisible: false,
                addReportVisible: false,
                navListLeft: this.$t("m.medicalReports.reportNavList"),
                isActive: 0,
                reportList: [],
                allReport: [],
                data1: [],
                data2: [], //data1是本人   data2是家属
                reportId: "",
                project: {},
                phyId: undefined,
                phyTime: "",
                phyVal: "",
                timeVal: "",
                fullscreenLoading: false,
                btnLoading: false,
                can_upload: false,
                comments: "",
                appraiseVisible: false,
                appraiseForm: {
                    relative_id: "",
                    cardiovascular_disease_history: "", //心血管家族病史
                    smoking_history: "", //吸烟史
                    acute_cardiovascular_events: "", //急性心血管事件
                    ldl_c_value: "", //低密度脂蛋白
                    hdl_c_value: "", //高密度脂蛋白
                    tc_value: "", //总胆固醇
                    diastolic_value: "", //舒张压值
                    systolic_value: "" //收缩压值
                },
                needList: [],
                userData: {},
                interpretListVisible: false,
                interpretListData: [],
                interpretForm: {},
                options: "",
                phyExPeoList: []
            };
        },
        components: {
            "v-header": header,
            "v-footer": footer
        },

        created() {
            let _this = this;
            _this.username = localStorage.getItem("username");
            _this.project = JSON.parse(sessionStorage.getItem("project"));
            _this.getReportList();
            // _this.getPhysical();
            axios.get(BASE_URL + "/exam/relatives/").then(res => {
                res.data.data.forEach(item => {
                    if (item.relationship == 0) {
                        _this.userId = item.id;
                    }
                });
            });
            if (localStorage.getItem("nationality") == "en") {
                // 英文
                _this.enIsZh = 1;
            } else {
                //中文
                _this.enIsZh = 2;
            }
        },
        methods: {
            keyUp(e) {
                e.target.value = e.target.value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
            },
            ...mapActions(["message"]),
            //删除体检报告
            removeReport(item) {
                this.$confirm(this.$t("m.common.deleteReport"), {
                        confirmButtonText: this.$t("m.common.define"),
                        cancelButtonText: this.$t("m.common.cancelBtn"),
                        type: "warning"
                    })
                    .then(() => {
                        axios
                            .post(`${BASE_URL}/exam/reports/delete/`, {
                                report_id: item.id
                            })
                            .then(res => {
                                this.$message.success(this.$t("m.afterMarket.edit.remove"));
                                this.getReportList();
                            })
                            .catch(err => {});
                    })
                    .catch(() => {});
            },
            getItem(item) {
                this.appraiseReId = item.relative.id;
                this.appraiseForm.relative_id = item.relative.id;
                this.appraiseForm.report_id = item.id;
                if (item.delivery_way != 0) {
                    let params = {
                        order_no: item.order_no,
                        report_id: item.id
                    };
                    axios
                        .get(BASE_URL + "/exam/abb/risk/index/info/", {
                            params: params
                        })
                        .then(res => {
                            if (res.data.data.is_appraisal) {
                                this.appraiseVisible = true;
                                this.needList = res.data.data.need_list;
                            } else {
                                this.$router.push({
                                    path: "/appraise",
                                    query: {
                                        score: res.data.data.score
                                    }
                                });
                            }
                        })
                        .catch(err => {});
                } else {
                    this.appraiseVisible = true;
                    this.needList = [
                        "systolic_value",
                        "diastolic_value",
                        "tc_value",
                        "ldl_c_value",
                        "hdl_c_value"
                    ];
                }
            },

            //取消报告预约解读
            cancelYY(item) {
                this.$confirm(this.$t("m.common.ConfirmCancellation"), {
                        confirmButtonText: this.$t("m.common.define"),
                        cancelButtonText: this.$t("m.common.cancelBtn"),
                        type: "warning"
                    })
                    .then(() => {
                        axios
                            .get(
                                `${BASE_URL}/exam/reports/interpret/${item.instance_id}/cancel`
                            )
                            .then(res => {
                                this.$message.success(this.$t("m.common.CancelSuccess"));
                                this.getInterpretList(this.checkInterpret);
                                this.getReportList();
                            })
                            .catch(err => {});
                    })
                    .catch(() => {});
            },
            // 面包屑跳转首页
            gotoindex() {
                this.$router.push("/phyExServices");
            },
            //获取可预约解读的时间段
            getInterpretTime(id) {
                this.fullscreenLoading = true;
                this.reportList.map((item, index) => {
                    if (item.id === id) {
                        this.checkReport = item;
                    }
                });
                this.interpretForm.name = this.checkReport.relative.name;
                this.interpretForm.contact = this.checkReport.relative.mobile;

                axios
                    .get(`${BASE_URL}/exam/reports/interpret/schedule/`)
                    .then(res => {
                        let arr = [];
                        res.data.data.map((item, index) => {
                            console.log(item, 111);
                            if (item.stock !== 0) {
                                console.log(222);
                                let obj = {
                                    label: `${item.work_date}【${
                  item.weekday == 0
                    ? this.$t("m.common.weekList[0]")
                    : item.weekday == 1
                    ? this.$t("m.common.weekList[1]")
                    : item.weekday == 2
                      ? this.$t("m.common.weekList[2]")
                      : item.weekday == 3
                        ? this.$t("m.common.weekList[3]")
                        : item.weekday == 4
                          ? this.$t("m.common.weekList[4]")
                          : item.weekday == 5
                            ? this.$t("m.common.weekList[5]")
                            : item.weekday == 6
                              ? this.$t("m.common.weekList[6]")
                              : ""
                }】`,
                                    value: `${item.id}-${item.id}`,
                                    children: [{
                                        label: `${item.start_time.split(" ")[1]} ~ ${
                      item.end_time.split(" ")[1]
                    }`,
                                        value: item.id
                                    }]
                                };
                                arr.push(obj);
                            }
                        });
                        let arr1 = this.unique(arr);
                        arr1.map((item, index) => {
                            arr.map((item1, index1) => {
                                if (item.label === item1.label) {
                                    let newChild = [...item.children, ...item1.children];
                                    item.children = this.unique(newChild);
                                }
                            });
                        });
                        this.fullscreenLoading = false;
                        this.options = arr1;
                    })
                    .catch(err => {
                        this.fullscreenLoading = false;
                    });
            },
            //对象数组去重
            unique(arr) {
                const res = new Map();
                return arr.filter(arr => !res.has(arr.label) && res.set(arr.label, 1));
            },
            //查看已约解读列表
            getInterpretList(item) {
                this.interpretListVisible = true;
                this.fullscreenLoading = true;
                this.checkInterpret = item;
                axios
                    .get(`${BASE_URL}/exam/reports/${item.id}/interpret/list/`)
                    .then(res => {
                        console.log(res);
                        this.interpretListData = res.data.data;
                        this.fullscreenLoading = false;
                    })
                    .catch(err => {
                        this.fullscreenLoading = false;
                    });
            },
            //提交疾病风险评估
            appraiseSubmit() {
                if (this.appraiseForm.cardiovascular_disease_history === "") {
                    this.$message.error("请选择有无心血管家族病史");
                } else if (this.appraiseForm.smoking_history === "") {
                    this.$message.error("请选择有无吸烟史");
                } else if (this.appraiseForm.acute_cardiovascular_events === "") {
                    this.$message.error("请选择有无急性心血管事件");
                } else if (
                    this.appraiseForm.ldl_c_value === "" &&
                    this.needList.indexOf("ldl_c_value") != -1
                ) {
                    this.$message.error("请填写低密度脂蛋白指数");
                } else if (
                    this.appraiseForm.hdl_c_value === "" &&
                    this.needList.indexOf("hdl_c_value") != -1
                ) {
                    this.$message.error("请填写高密度脂蛋白指数");
                } else if (
                    this.appraiseForm.tc_value === "" &&
                    this.needList.indexOf("tc_value") != -1
                ) {
                    this.$message.error("请填写总胆固醇指数");
                } else if (
                    this.appraiseForm.diastolic_value === "" &&
                    this.needList.indexOf("diastolic_value") != -1
                ) {
                    this.$message.error("请填写舒张压指数");
                } else if (
                    this.appraiseForm.systolic_value === "" &&
                    this.needList.indexOf("systolic_value") != -1
                ) {
                    this.$message.error("请填写收缩压指数");
                } else {
                    this.btnLoading = true;
                    for (var i in this.appraiseForm) {
                        if (this.appraiseForm[i] === "") {
                            delete this.appraiseForm[i];
                        }
                    }
                    axios
                        .post(BASE_URL + "/exam/abb/risk/cardiovascular/", this.appraiseForm)
                        .then(res => {
                            // console.log(res);
                            this.appraiseVisible = false;
                            this.btnLoading = false;
                            this.$router.push({
                                path: "/appraise",
                                query: {
                                    score: res.data.data.score
                                }
                            });
                        })
                        .catch(err => {
                            this.btnLoading = false;
                        });
                }
            },

            // 下载体检报告
            downloadReport(baseurl) {
                axios({
                    method: "get",
                    url: baseurl,
                    responseType: "blob"
                }).then(res => {
                    console.log(response);
                    let response = res.data;
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        const blob = new Blob([response]);
                        window.navigator.msSaveOrOpenBlob(blob, "体检报告.pdf");
                    } else {
                        /* 火狐谷歌的文件下载方式 */
                        var blob = new Blob([response], {
                            type: "application/octet-stream"
                        });
                        var downloadElement = document.createElement("a");
                        var href = window.URL.createObjectURL(blob);
                        downloadElement.href = href;
                        downloadElement.download = "体检报告.pdf";
                        document.body.appendChild(downloadElement);
                        downloadElement.click();
                        document.body.removeChild(downloadElement);
                        window.URL.revokeObjectURL(href);
                    }
                });
            },
            getReportImg(content) {
                let _this = this;
                var contentTokenImg = [];
                var Token = localStorage.getItem("TOKEN");
                for (var i = 0; i < content.length; i++) {
                    contentTokenImg.push(content[i] + "&token=" + Token);
                }
                sessionStorage.setItem("reportImgs", contentTokenImg);
                _this.$router.push({
                    path: "/reportImg"
                });
            },
            //点击选择体检时间
            getTime(val) {
                console.log(val);
                let _this = this;
                _this.phyTime = val;
            },
            //选择体检人
            changePhy(val) {
                console.log(val);
                let _this = this;
                _this.phyId = val;
            },
            //检测文件变动获取文件
            fileChange(file, fileList) {
                this.fileList = fileList;
                console.log(file);
            },
            //检测文件删除
            fileRemove(file, fileList) {
                this.fileList = fileList;
            },
            //判断数组内元素是否全相同
            isAllEqual(array) {
                if (array.length > 0) {
                    return !array.some(function(value, index) {
                        return value !== array[0];
                    });
                } else {
                    return true;
                }
            },
            //手动提交上传
            submitUpload() {
                let _this = this;
                // if (!_this.phyId) {
                //     let data = {
                //         message: _this.$t("m.medicalReports.choosePhyPerson"),
                //         type: "error",
                //         center: true,
                //     };
                //     _this.message(data);
                // } else
                if (!_this.phyTime) {
                    let data = {
                        message: _this.$t("m.medicalReports.choosePhyTime"),
                        type: "error",
                        center: true
                    };
                    _this.message(data);
                } else if (_this.fileList.length === 0) {
                    let data = {
                        message: _this.$t("m.medicalReports.chooseFile"),
                        type: "error",
                        center: true
                    };
                    _this.message(data);
                } else if (_this.fileList.length > 9) {
                    let data = {
                        message: _this.$t("m.medicalReports.fileNum"),
                        type: "error",
                        center: true
                    };
                    _this.message(data);
                } else {
                    // _this.btnLoading = true;
                    let fileType = [];
                    let fd = new FormData(); // FormData 对象
                    _this.fileList.forEach(file => {
                        fd.append("files", file.raw);
                        fileType.push(file.name.split(".")[1]);
                    });
                    fd.append("relative", _this.userId);
                    fd.append("exam_date", _this.phyTime);
                    let url = BASE_URL + "/exam/reports/uploading/";
                    let config = {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    };
                    if (_this.isAllEqual(fileType)) {
                        axios
                            .post(url, fd, config)
                            .then(res => {
                                _this.btnLoading = false;
                                _this.addReportVisible = false;
                                let data = {
                                    message: _this.$t("m.medicalReports.uploadSuccess"),
                                    type: "success",
                                    center: true
                                };
                                _this.message(data);
                                _this.getReportList();
                            })
                            .catch(err => {
                                _this.btnLoading = false;
                            });
                        _this.$refs.upload.submit();
                    } else {
                        _this.$message.error(_this.$t("m.common.updateFile"));
                    }
                }
            },
            // 点击新增体检报告按钮
            addReport() {
                let _this = this;
                _this.phyVal = "";
                _this.phyId = "";
                _this.timeVal = "";
                _this.phyTime = "";
                _this.fileList = [];
                _this.addReportVisible = true;
            },
            //提交预约解读的信息
            submit() {
                if (this.interpretForm.name.match(/^[ ]*$/)) {
                    this.$message.error(
                        this.$t("m.medicalReports.writeInterpret.inputName")
                    );
                } else if (this.interpretForm.contact === "") {
                    this.$message.error(
                        this.$t("m.medicalReports.writeInterpret.inputPhone")
                    );
                } else if (!phoneReg.test(this.interpretForm.contact)) {
                    this.$message.error(
                        this.$t("m.medicalReports.writeInterpret.successPhone")
                    );
                } else if (this.interpretForm.schedule.length === 0) {
                    this.$message.error(
                        this.$t("m.medicalReports.writeInterpret.inputTime")
                    );
                } else if (this.interpretForm.doubt === "") {
                    this.$message.error(this.$t("m.common.txYw"));
                } else if (this.interpretForm.doubt.length < 20) {
                    this.$message.error(this.$t("m.common.dontSaveTxt"));
                } else {
                    this.btnLoading = true;
                    let param = {
                        contact: this.interpretForm.contact,
                        doubt: this.interpretForm.doubt,
                        name: this.interpretForm.name,
                        schedule: this.interpretForm.schedule[1]
                    };
                    axios
                        .post(
                            `${BASE_URL}/exam/reports/${this.checkReport.id}/interpret/`,
                            param
                        )
                        .then(res => {
                            this.btnLoading = false;
                            this.interpretVisible = false;
                            this.$message.success(
                                this.$t("m.medicalReports.writeInterpret.successMsg")
                            );
                            this.getReportList();
                        })
                        .catch(err => {
                            this.btnLoading = false;
                            // this.interpretVisible = false;
                        });
                }
            },
            interpret(id) {
                let _this = this;
                _this.interpretVisible = true;
                _this.reportId = id;
                this.interpretForm = {
                    contact: "",
                    doubt: "",
                    name: "",
                    schedule: ""
                };
                // _this.$refs.msg.value = "";
                // _this.$refs.touch.value = "";
                _this.getInterpretTime(id);
            },
            //跳转订单页面
            gotorder() {
                this.$router.push({
                    path: '/phyOrderList',
                    query: {
                        check: 0,
                        statusType: 0,
                    }
                })
            },
            //获取体检报告列表
            getReportList() {
                let _this = this;
                _this.fullscreenLoading = true;
                axios
                    .get(BASE_URL + "/exam/reports/")
                    .then(res => {
                        _this.fullscreenLoading = false;
                        _this.reportList = res.data.data;
                        _this.allReport = res.data.data;
                        _this.reportList.forEach(function(element) {
                            if (element.relative.relationship == 0) {
                                _this.data1.push(element);
                            } else {
                                _this.data2.push(element);
                            }
                        });
                    })
                    .catch(err => {
                        _this.fullscreenLoading = false;
                    });
            },
            //查看多久的订单
            // handleCommand(command) {
            //   this.$message('click on item ' + command);
            // },
            //切换nav
            changeNav(index) {
                let _this = this;
                _this.isActive = index;
                if (index == 0) {
                    _this.reportList = _this.allReport;
                } else if (index == 1) {
                    _this.reportList = _this.data1;
                } else if (index == 2) {
                    _this.reportList = _this.data2;
                }
            }
        },
        computed: {}
    };
</script>

<style scoped>
    .username {
        font-size: 16px;
        margin-left: -22px;
    }
    
    #jd_status {
        display: flex;
        justify-content: flex-end;
    }
    
    #jd_status p {
        font-size: 14px;
        font-weight: 400;
        color: #ff000f;
        line-height: 21px;
        cursor: pointer;
        text-decoration: underline;
    }
    
    #jd_status1 {
        display: flex;
        justify-content: flex-end;
    }
    
    #jd_status1 p {
        color: #c91f1f !important;
    }
    
    #writeInterpret .item {
        display: flex;
        align-items: center;
        width: 490px;
        margin-bottom: 30px;
    }
    
    #writeInterpret .item:last-child {
        margin-bottom: 0;
    }
    
    #writeInterpret .item .left {
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    
    #writeInterpret .item .left p {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 24px;
    }
    
    #writeInterpret .item .right {
        width: 100%;
        flex: 1;
        margin-left: 30px;
    }
    
    #interpretList {
        width: 100%;
        height: 500px;
        overflow-y: auto;
    }
    
    #interpretList .item {
        width: 100%;
        padding: 20px 20px;
        margin-bottom: 30px;
        border: 1px solid #ededed;
    }
    
    #interpretList .item .item1 {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    
    #interpretList .item .item1:last-child {
        margin-bottom: 0;
    }
    
    #interpretList .item .item1 .left {
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 24px;
    }
    
    #interpretList .item .item1 .right {
        flex: 1;
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        margin-left: 30px;
        text-align: justify;
    }
    
    .uploadFile {
        padding: 0 30px;
        margin-top: 30px !important;
    }
    
    .uploadMsg {
        padding: 0 30px;
        margin-top: 30px;
    }
    
    .addMsg .time {
        margin-top: 30px !important;
    }
    
    .addMsg .person,
    .addMsg .time,
    .addMsg .uploadFile {
        display: flex;
        margin-top: 50px;
        align-items: center;
        padding: 0 30px;
    }
    
    .addMsg .person .icon,
    .addMsg .time .icon,
    .addMsg .uploadFile .icon {
        width: 4px;
        height: 18px;
        background: #ff000f;
    }
    
    .addMsg .uploadFile .title {
        width: 100% !important;
    }
    
    .addMsg .person .title,
    .addMsg .time .title,
    .addMsg .uploadFile .title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
        width: 230px;
    }
    
    .addMsg .tit {
        font-size: 24px;
        font-weight: 500;
        color: #333;
        line-height: 24px;
        text-align: center;
    }
    
    .nayReport {
        width: 1180px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 100px 0;
    }
    /* .nayReport img {
      width: 380px;
      height: 214px;
    } */
    
    .nayReport p {
        font-size: 16px;
        font-weight: 400;
        color: #999;
        line-height: 16px;
        margin-top: 30px;
    }
    
    .phone textarea {
        height: 120px !important;
    }
    
    .msg textarea {
        width: 100%;
        height: 180px;
        border: 1px solid #ccc;
        padding: 30px;
        margin-top: 30px;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
    }
    
    .msg span {
        display: inline-block;
        margin-top: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #999;
    }
    
    .msg .msgTit {
        display: flex;
        margin-top: 40px;
    }
    
    .msg .msgTit p:nth-child(1) {
        width: 4px;
        height: 18px;
        background: #046bde;
    }
    
    .msg .msgTit p:nth-child(2) {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .interpretMsg .line {
        width: 100%;
        height: 2px;
        background: #eaeaea;
        margin-top: 9px;
    }
    
    .interpretMsg .online {
        display: flex;
        justify-content: flex-end;
    }
    
    .interpretMsg .online p {
        font-size: 16px;
        font-weight: 600;
        color: #046bde;
        line-height: 16px;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .interpretMsg .tit {
        /* width: 190px; */
        height: 46px;
        /* background: #046BDE; */
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }
    
    .interpretMsg .tit p {
        font-size: 24px;
        font-weight: 600;
        color: #333;
        line-height: 24px;
    }
    
    .interpretMsg {
        width: 900px;
        margin: 0 auto;
    }
    
    .medicalItem .name {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .medicalItem .name p {
        font-size: 14px;
        width: 200px;
        word-wrap: break-word;
        padding: 0 10px;
        font-weight: 600;
        color: #333;
        line-height: 14px;
        text-align: center;
    }
    
    .medicalItem .msg {
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .medicalItem .msg p:nth-child(1),
    .medicalItem .msg p:nth-child(3),
    .medicalItem .time p {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 14px;
    }
    
    .medicalItem .msg p:nth-child(2) {
        width: 400px;
        height: 2px;
        background: #eaeaea;
        margin: 10px 0;
    }
    
    .medicalItem .time {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .medicalItem .handle {
        width: 280px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .medicalItem .handle p {
        font-size: 16px;
        font-weight: 600;
        color: #ff000f;
        line-height: 18px;
        text-decoration: underline;
        margin-top: 15px;
        cursor: pointer;
    }
    
    .medicalItem .handle p:nth-child(1) {
        margin-top: 0;
    }
    
    .medicalItem {
        width: 100%;
        border: 1px solid #ccc;
        display: flex;
        align-items: center;
        padding: 30px 0;
        margin-bottom: 30px;
    }
    
    .medicalList {
        width: 1180px;
        margin: 0 auto;
    }
    
    .titList {
        width: 1180px;
        margin: 0 auto;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .titList p {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        line-height: 14px;
    }
    
    .titList .name {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .titList .msg {
        width: 500px;
        display: flex;
        justify-content: center;
    }
    
    .titList .time {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .titList .handle {
        width: 280px;
        display: flex;
        justify-content: center;
    }
    
    .nav {
        width: 100%;
        border-bottom: 2px solid #eaeaea;
    }
    
    .navChild {
        width: 1180px;
        height: 50px;
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
    }
    
    .navChild .left {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .navChild .left p {
        font-weight: 600;
        cursor: pointer;
        color: #333;
        font-size: 16px;
    }
    
    .active {
        color: #046bde !important;
        font-size: 18px !important;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #eaeaea;
        display: flex;
        align-items: center;
    }
    
    .breadNav p {
        width: 1180px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
    }
    
    .breadNav p .addReport {
        font-size: 16px;
        font-weight: normal;
        display: inlin-block;
        color: #ff000f;
        line-height: 16px;
        cursor: pointer;
    }
    
    .appraiseMsg {
        width: 100%;
        height: 50px;
        border: 1px solid #dfdfdf;
        border-radius: 4px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 0 20px;
    }
    
    .appraiseMsg p {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 16px;
    }
    
    .appraiseTit {
        display: flex;
        margin-top: 40px;
        margin-bottom: 30px;
    }
    
    .appraiseTit i {
        width: 4px;
        height: 16px;
        display: block;
        background: #e94709;
    }
    
    .appraiseTit p {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 16px;
        margin-left: 10px;
    }
    
    .uploadFile {
        padding: 0 30px;
        margin-top: 30px !important;
    }
    
    .uploadMsg {
        padding: 0 30px;
        margin-top: 30px;
    }
    
    .addMsg .time {
        margin-top: 30px !important;
    }
    
    .addMsg .person,
    .addMsg .time,
    .addMsg .uploadFile {
        display: flex;
        margin-top: 50px;
        align-items: center;
        padding: 0 30px;
    }
    
    .addMsg .person .icon,
    .addMsg .time .icon,
    .addMsg .uploadFile .icon {
        width: 4px;
        height: 18px;
        background: #e94709;
    }
    
    .addMsg .uploadFile .title {
        width: 100% !important;
    }
    
    .addMsg .person .title,
    .addMsg .time .title,
    .addMsg .uploadFile .title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
        width: 180px;
    }
    
    .addMsg .tit {
        font-size: 24px;
        font-weight: 500;
        color: #333;
        line-height: 24px;
        text-align: center;
    }
    
    .nayReport {
        width: 1180px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 100px 0;
    }
    
    .nayReport img {
        width: 380px;
        height: 214px;
    }
    
    .nayReport p {
        font-size: 16px;
        width: 500px;
        font-weight: 400;
        color: #999;
        line-height: 26px;
        text-align: center;
        margin-top: 30px;
    }
    
    .phone textarea {
        height: 120px !important;
    }
    
    .msg textarea {
        width: 100%;
        height: 180px;
        border: 1px solid #ccc;
        padding: 30px;
        margin-top: 30px;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
    }
    
    .msg .msgTit {
        display: flex;
        margin-top: 40px;
    }
    
    .msg .msgTit p:nth-child(1) {
        width: 4px;
        height: 18px;
        background: #e94709;
    }
    
    .msg .msgTit p:nth-child(2) {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .interpretMsg .line {
        width: 100%;
        height: 2px;
        background: #eaeaea;
        margin-top: 9px;
    }
    
    .interpretMsg .online {
        display: flex;
        justify-content: flex-end;
    }
    
    .interpretMsg .online p {
        font-size: 16px;
        font-weight: 600;
        color: #e94709;
        line-height: 16px;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .interpretMsg .tit {
        /* width: 190px; */
        height: 46px;
        /* background: #e94709; */
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }
    
    .interpretMsg .tit p {
        font-size: 24px;
        font-weight: 600;
        color: #333;
        line-height: 24px;
    }
    
    .interpretMsg {
        width: 900px;
        margin: 0 auto;
    }
    
    .medicalItem .name {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .medicalItem .name p {
        font-size: 14px;
        width: 200px;
        word-wrap: break-word;
        padding: 0 10px;
        font-weight: 600;
        color: #333;
        line-height: 14px;
        text-align: center;
    }
    
    .medicalItem .msg {
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .medicalItem .msg p:nth-child(1),
    .medicalItem .msg p:nth-child(3),
    .medicalItem .time p {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 14px;
    }
    
    .medicalItem .msg p:nth-child(2) {
        width: 400px;
        height: 2px;
        background: #eaeaea;
        margin: 10px 0;
    }
    
    .medicalItem .time {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .medicalItem .handle {
        width: 280px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .medicalItem .handle p {
        font-size: 16px;
        font-weight: 600;
        color: #ff000f;
        line-height: 18px;
        text-decoration: underline;
        margin-top: 15px;
        cursor: pointer;
    }
    
    .medicalItem .handle p:nth-child(1) {
        margin-top: 0;
    }
    
    .medicalItem {
        width: 100%;
        border: 1px solid #ccc;
        display: flex;
        align-items: center;
        padding: 30px 0;
        margin-bottom: 30px;
    }
    
    .medicalList {
        width: 1180px;
        margin: 0 auto;
    }
    
    .titList {
        width: 1180px;
        margin: 0 auto;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .titList p {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        line-height: 14px;
    }
    
    .titList .name {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .titList .msg {
        width: 500px;
        display: flex;
        justify-content: center;
    }
    
    .titList .time {
        width: 200px;
        display: flex;
        justify-content: center;
    }
    
    .titList .handle {
        width: 280px;
        display: flex;
        justify-content: center;
    }
    
    .nav {
        width: 100%;
        border-bottom: 2px solid #eaeaea;
    }
    
    .navChild {
        width: 1180px;
        height: 50px;
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
    }
    
    .navChild .left {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .navChild .left p {
        font-weight: 600;
        cursor: pointer;
        color: #333;
        font-size: 16px;
    }
    
    .active {
        color: #e94709 !important;
        font-size: 18px !important;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #eaeaea;
        display: flex;
        align-items: center;
    }
    
    .breadNav p {
        width: 1180px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
        display: flex;
        justify-content: space-between;
    }
    
    .breadNav p .addReport {
        font-size: 16px;
        font-weight: normal;
        color: #ff000f;
        line-height: 16px;
        cursor: pointer;
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/medicalReports/list.vue